import { useMutation, useQuery, useQueryClient } from 'react-query';
import { APIErrorType } from '../../api';
import {
  createPayment,
  CreatePaymentDataType,
  fetchPayment,
  PaymentCreateType,
  PaymentType
} from '../../api/payment';
import { UseQueryResult } from 'react-query/types/react/types';

export type usePaymentReturnType = UseQueryResult<PaymentType>;

export function usePayment(paymentId: number | undefined): usePaymentReturnType {
  if (!paymentId) throw Error('paymentId is undefiend');
  return useQuery<PaymentType, APIErrorType>(['payment', paymentId], () => fetchPayment(paymentId));
}

export function useCreatePaymentMutation() {
  const queryClient = useQueryClient();

  return useMutation<PaymentCreateType, APIErrorType, CreatePaymentDataType>(createPayment, {
    onSuccess: async payment => {
      await queryClient.invalidateQueries('exams');
      queryClient.setQueryData(['payment', payment.id], payment);
    }
  });
}
